import { ComponentChildren, h } from 'preact';
import { Icon } from 'components/icon/icon';
import { useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { redirectToDashboard } from 'helpers/redirect-to-dashboard';
import { headerStore } from 'global/header.store';
import { A11YIcon } from '@uw/icons';
import {
  SecondaryList,
  SecondaryListItem,
} from 'components/secondary-list-item/secondary-list-item';

type SettingsLink = {
  label: string;
  path: string;
  ariaLabel: string;
  icon: ComponentChildren;
};

export const AddonsAndSettings = () => {
  const { tunings } = useContext(ApplicationContext);
  const siteName = tunings.site_name ?? '';

  const settingsLinks: SettingsLink[] = [
    {
      label: 'Account settings',
      path: '/settings/general',
      ariaLabel: 'Account settings, opens in a new tab',
      icon: <Icon type="user" />,
    },
    {
      label: 'Sites',
      path: '/widget/my-sites/p/1',
      ariaLabel: 'Sites, opens in a new tab',
      icon: <Icon type="globe" />,
    },
    {
      label: 'Widget settings',
      path: `/widget/my-sites/p/1/site-details/settings?site=${siteName}`,
      ariaLabel: 'Widget settings, opens in a new tab',
      icon: <A11YIcon height={20} width={20} />,
    },
    {
      label: 'Addons',
      path: `/widget/my-sites/p/1/site-details/addons?site=${siteName}`,
      ariaLabel: 'Addons, opens in a new tab',
      icon: <Icon type="puzzle" />,
    },
  ];

  useEffect(() => {
    headerStore.title.next(`Settings`);
  }, []);

  return (
    <SecondaryList>
      {settingsLinks.map((link) => (
        <SecondaryListItem
          key={link.label}
          label={link.label}
          leadingIcon={link.icon}
          ariaLabel={link.ariaLabel}
          href="#"
          onClick={() => redirectToDashboard(link.path)}
        />
      ))}
    </SecondaryList>
  );
};
